<template>
    <div style="height:85vh;">
        <Breadcrumbs title="Bot Training" />
        <div class="d-flex flex-column" style="height: 80vh; font-size: 0.875rem; overflow: hidden;">
            <!-- Export / Import -->
            <div class="d-flex justify-content-end mb-3 flex-shrink-0" style="gap: 0.5rem;">
                <b-button variant="secondary" class="border m-0" @click="exportJSON">
                    <i class="icofont icofont-upload-alt"></i> Export
                </b-button>
                <b-button variant="info" class="border m-0" v-b-modal="'modal-import-json'">
                    <i class="icofont icofont-download-alt"></i> Import
                </b-button>
            </div>

            <ImportJsonModal modal-id="modal-import-json" :template-data="importTemplate"
                template-file-name="bot-training-template.json" :required-fields="importRequiredFields"
                @imported="onImported" />

            <TestCaseResultModal :row="selectedRow" />

            <!-- 3-column grid -->
            <div class="flex-grow-1 overflow-hidden training-grid">
                <!-- Keyword Open Incident -->
                <div class="bg-white rounded d-flex flex-column"
                    style="padding: 1rem; box-shadow: 0 1px 3px rgba(0,0,0,0.1); overflow: hidden;">
                    <h6 class="font-weight-bold mb-3 flex-shrink-0" style="color: #1f2937;">Keyword Open Incident</h6>
                    <div class="d-flex mb-2 flex-shrink-0" style="position: relative;">
                        <font-awesome-icon icon="fa-solid fa-search"
                            style="position: absolute; left: 0.5rem; top: 50%; transform: translateY(-50%); color: #9ca3af; font-size: 0.7rem; pointer-events: none;" />
                        <input v-model="searchOpenIncident" type="text" placeholder="Search"
                            class="form-control form-control-sm"
                            style="min-width: 0; border-color: #d1d5db; padding-left: 1.6rem; padding-right: 1.5rem;" />
                        <button v-if="searchOpenIncident" @click="searchOpenIncident = ''"
                            class="btn p-0 border-0 bg-transparent"
                            style="position: absolute; right: 0.6rem; top: 50%; transform: translateY(-50%); color: #9ca3af; line-height: 1;">
                            <font-awesome-icon icon="fa-solid fa-times" style="font-size: 0.8rem;" />
                        </button>
                    </div>
                    <div class="d-flex mb-3 flex-shrink-0" style="gap: 0.5rem;">
                        <input v-model="openInput" type="text" placeholder="Keywords (comma separated)"
                            class="form-control form-control-sm" style="min-width: 0; border-color: #d1d5db;"
                            @keypress.enter="addKeyword('open-incident')" />
                        <button @click="addKeyword('open-incident')"
                            class="btn text-white font-weight-bold flex-shrink-0"
                            style="background-color: #7c3aed; padding: 0.25rem 0.6rem; font-size: 0.875rem; line-height: 1;">
                            +
                        </button>
                    </div>
                    <ul class="list-unstyled flex-grow-1 mb-0"
                        style="overflow-y: auto; margin: 0 -1rem; padding: 0 1rem;">
                        <li v-for="kw in filteredOpenKeywords" :key="kw"
                            class="keyword-row d-flex align-items-center justify-content-between"
                            style="border-bottom: 1px solid #f9fafb; padding: 0.25rem 0.5rem;">
                            <span @click="appendToOpenSearch(kw)" style="color: #374151; cursor: pointer;">{{ kw
                            }}</span>
                            <button @click="removeKeyword('open-incident', kw)" class="btn btn-sm p-0 ml-2 trash-btn">
                                <font-awesome-icon icon="fa-solid fa-trash"
                                    style="font-size: 0.75rem; pointer-events: none; cursor: pointer;" />
                            </button>
                        </li>
                    </ul>
                </div>

                <!-- Keyword Not Open Incident -->
                <div class="bg-white rounded d-flex flex-column"
                    style="padding: 1rem; box-shadow: 0 1px 3px rgba(0,0,0,0.1); overflow: hidden;">
                    <h6 class="font-weight-bold mb-3 flex-shrink-0" style="color: #1f2937;">Keyword Not Open Incident
                    </h6>
                    <div class="d-flex mb-2 flex-shrink-0" style="position: relative;">
                        <font-awesome-icon icon="fa-solid fa-search"
                            style="position: absolute; left: 0.5rem; top: 50%; transform: translateY(-50%); color: #9ca3af; font-size: 0.7rem; pointer-events: none;" />
                        <input v-model="searchNotOpenIncident" type="text" placeholder="Search"
                            class="form-control form-control-sm"
                            style="min-width: 0; border-color: #d1d5db; padding-left: 1.6rem; padding-right: 1.5rem;"
                            @input="onSearchNotOpenIncident" />
                        <button v-if="searchNotOpenIncident" @click="searchNotOpenIncident = ''"
                            class="btn p-0 border-0 bg-transparent"
                            style="position: absolute; right: 0.6rem; top: 50%; transform: translateY(-50%); color: #9ca3af; line-height: 1;">
                            <font-awesome-icon icon="fa-solid fa-times" style="font-size: 0.8rem;" />
                        </button>
                    </div>
                    <div class="d-flex mb-3 flex-shrink-0" style="gap: 0.5rem;">
                        <input v-model="notOpenInput" type="text" placeholder="Keywords (comma separated)"
                            class="form-control form-control-sm" style="min-width: 0; border-color: #d1d5db;"
                            @keypress.enter="addKeyword('not-open-incident')" />
                        <button @click="addKeyword('not-open-incident')"
                            class="btn text-white font-weight-bold flex-shrink-0"
                            style="background-color: #7c3aed; padding: 0.25rem 0.6rem; font-size: 0.875rem; line-height: 1;">
                            +
                        </button>
                    </div>
                    <ul class="list-unstyled flex-grow-1 mb-0"
                        style="overflow-y: auto; margin: 0 -1rem; padding: 0 1rem;">
                        <li v-for="kw in filteredNotOpenKeywords" :key="kw"
                            class="keyword-row d-flex align-items-center justify-content-between"
                            style="border-bottom: 1px solid #f9fafb; padding: 0.25rem 0.5rem;">
                            <span @click="appendToNotOpenSearch(kw)" style="color: #374151; cursor: pointer;">{{ kw
                            }}</span>
                            <button @click="removeKeyword('not-open-incident', kw)"
                                class="btn btn-sm p-0 ml-2 trash-btn">
                                <font-awesome-icon icon="fa-solid fa-trash"
                                    style="font-size: 0.75rem; pointer-events: none; cursor: pointer;" />
                            </button>
                        </li>
                    </ul>
                </div>

                <!-- Test Sentences -->
                <div class="bg-white rounded d-flex flex-column overflow-hidden"
                    style="padding: 1rem; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
                    <!-- Header -->
                    <div class="d-flex align-items-center justify-content-between mb-3 flex-shrink-0">
                        <div class="d-flex align-items-center" style="gap: 0.5rem;">
                            <h6 class="font-weight-bold mb-0" style="color: #1f2937;">Test Case</h6>
                        </div>
                        <div class="d-flex align-items-center" style="gap: 0.375rem;">
                            <span style="font-size: 0.7rem; color: #6b7280;">Enable Bot</span>
                            <toggle-button sync v-model="isEnabled" :labels="{ checked: 'On', unchecked: 'Off' }"
                                :width="48" />
                        </div>
                    </div>

                    <!-- Result summary -->
                    <div v-if="showSummary" class="mb-3 flex-shrink-0" style="display: flex; gap: 0.75rem;">
                        <div class="d-flex align-items-center"
                            style="gap: 0.5rem; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 0.25rem; padding: 0.375rem 0.75rem;">
                            <font-awesome-icon icon="fa-solid fa-check-circle"
                                style="color: #16a34a; font-size: 0.75rem;" />
                            <span style="color: #15803d; font-size: 0.75rem; font-weight: 600;">Pass: {{ passCount
                            }}</span>
                        </div>
                        <div @click="scrollToNextFail" class="d-flex align-items-center"
                            style="gap: 0.5rem; background: #fef2f2; border: 1px solid #fecaca; border-radius: 0.25rem; padding: 0.375rem 0.75rem; cursor: pointer;">
                            <font-awesome-icon icon="fa-solid fa-times-circle"
                                style="color: #ef4444; font-size: 0.75rem;" />
                            <span style="color: #dc2626; font-size: 0.75rem; font-weight: 600;">Fail: {{ failCount
                            }}</span>
                        </div>
                    </div>

                    <!-- Hint + Add Row -->
                    <div class="mb-2 d-flex align-items-center justify-content-between flex-shrink-0">
                        <p class="mb-0" style="color: #ef4444; font-size: 0.75rem;">*Press Enter to add a new row</p>
                        <div class="d-flex" style="gap: 0.5rem;">
                            <button @click="addSentenceRow()" class="btn btn-sm btn-light"
                                style="color: #374151; font-size: 0.75rem;">
                                + Add Row
                            </button>
                            <button @click="clearAll" class="btn btn-danger btn-sm">
                                Clear
                            </button>
                            <button :disabled="isTesting" @click="testSentences" class="btn btn-primary btn-sm">
                                {{ testBtnText }}
                            </button>
                            <button @click="saveSession" class="btn btn-sm text-white"
                                style="background-color: #059669;">
                                {{ saveBtnText }}
                            </button>
                        </div>
                    </div>

                    <!-- Search sentences -->
                    <div class="d-flex mb-2 flex-shrink-0" style="position: relative;">
                        <font-awesome-icon icon="fa-solid fa-search"
                            style="position: absolute; left: 0.5rem; top: 50%; transform: translateY(-50%); color: #9ca3af; font-size: 0.7rem; pointer-events: none;" />
                        <input v-model="searchSentence" type="text" placeholder="Search"
                            class="form-control form-control-sm"
                            style="min-width: 0; border-color: #d1d5db; padding-left: 1.6rem; padding-right: 1.5rem;" />
                        <button v-if="searchSentence" @click="searchSentence = ''"
                            class="btn p-0 border-0 bg-transparent"
                            style="position: absolute; right: 0.6rem; top: 50%; transform: translateY(-50%); color: #9ca3af; line-height: 1;">
                            <font-awesome-icon icon="fa-solid fa-times" style="font-size: 0.8rem;" />
                        </button>
                    </div>

                    <!-- Progress bar -->
                    <div v-show="showProgress" class="mb-3 flex-shrink-0">
                        <div class="d-flex align-items-center justify-content-between mb-1">
                            <span style="font-size: 0.75rem; color: #6b7280;">{{ testDone }} / {{ testTotal }}
                                sentences</span>
                            <span style="font-size: 0.75rem; font-weight: 600; color: #4b5563;">{{ progressPct
                            }}%</span>
                        </div>
                        <div class="progress" style="height: 0.5rem;">
                            <div class="progress-bar bg-primary"
                                :style="{ width: progressPct + '%', transition: 'width 0.3s' }"></div>
                        </div>
                    </div>

                    <!-- Sentence rows -->
                    <div ref="sentenceRowsContainer" class="flex-grow-1"
                        style="overflow-y: auto; border-top: 1px solid #f3f4f6;">
                        <div v-for="row in filteredSentenceRows" :key="row.id"
                            class="sentence-row d-flex align-items-center my-1 rounded"
                            style="padding: 0.5rem; gap: 0.75rem;" :style="rowBgStyle(row)">
                            <select v-model="row.expect" @change="invalidateSavedState"
                                class="form-control form-control-sm flex-shrink-0"
                                style="width: auto; font-size: 0.75rem; border-color: #d1d5db;">
                                <option value="opencase">opencase</option>
                                <option value="not-opencase">not-opencase</option>
                            </select>
                            <input type="text" v-model="row.value" class="sentence-input flex-grow-1"
                                style="border: none; background: transparent; font-size: 0.875rem; color: #374151; outline: none; padding: 0.25rem 0; line-height: 1.6;"
                                :placeholder="row.emptyWarning ? 'Please enter a sentence or remove this row' : 'Type a sentence, then press Enter...'"
                                @input="onSentenceInput(row)"
                                @keydown.enter.prevent="onSentenceEnter(sentenceRows.indexOf(row))"
                                @blur="onSentenceBlur(row)" @paste="onSentencePaste($event, row)" />
                            <div class="sentence-result flex-shrink-0 d-flex align-items-center justify-content-end"
                                style="min-width: 72px;">
                                <span v-if="row.result !== null" style="font-size: 0.75rem; font-weight: 600;"
                                    :style="{ color: row.isCorrect ? '#16a34a' : '#ef4444' }">{{ row.result }}</span>
                                <button v-else class="btn p-0 border-0 bg-transparent sentence-search-btn"
                                    @click="appendToSentenceSearch(row.value)" title="Search this sentence">
                                    <font-awesome-icon icon="fa-solid fa-search"
                                        style="font-size: 0.65rem; pointer-events: none;" />
                                </button>
                            </div>
                            <span type="button" @click="row.result !== null && openRowDetail(row)"
                                class="btn btn-sm p-0 flex-shrink-0"
                                :style="{ color: row.result !== null ? '#3b82f6' : '#d1d5db', cursor: row.result !== null ? 'pointer' : 'not-allowed' }">
                                <font-awesome-icon icon="fa-solid fa-question-circle"
                                    style="pointer-events: none;" />
                            </span>
                            <span type="button" @click="deleteSentenceRow(sentenceRows.indexOf(row))"
                                class="btn btn-sm p-0 flex-shrink-0 trash-btn">
                                <font-awesome-icon icon="fa-solid fa-trash"
                                    style="pointer-events: none; cursor: pointer;" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ImportJsonModal from '@/components/import/import-json-modal.vue'
import TestCaseResultModal from '@/components/bot-training/test-case-result-modal.vue'
import { requestService } from './../../_services';

export default {
    name: 'BotTraining',
    components: { ImportJsonModal, TestCaseResultModal },

    data() {
        return {
            importTemplate: {
                open_incident: { keywords: ['keyword1', 'keyword2'], test_cases: ['sentence1', 'sentence2'] },
                not_open_incident: { keywords: ['keyword3'], test_cases: ['sentence3'] },
            },
            importRequiredFields: [
                { key: 'open_incident.keywords' },
                { key: 'open_incident.test_cases' },
                { key: 'not_open_incident.keywords' },
                { key: 'not_open_incident.test_cases' },
            ],
            openKeywords: [],
            notOpenKeywords: [],
            openInput: '',
            notOpenInput: '',
            sentenceRows: [],
            rowIdCounter: 0,
            lastFailIndex: -1,
            isTesting: false,
            testDone: 0,
            testTotal: 0,
            passCount: 0,
            failCount: 0,
            showSummary: false,
            showProgress: false,
            saveBtnText: 'Save',
            testBtnText: 'Test',
            isEnabled: true,
            searchOpenIncident: '',
            searchNotOpenIncident: '',
            searchSentence: '',
            selectedRow: null,
        }
    },

    computed: {
        progressPct() {
            if (this.testTotal <= 0) return 0
            return Math.round((this.testDone / this.testTotal) * 100)
        },
        filteredOpenKeywords() {
            const terms = this.searchOpenIncident.split(',').map(s => s.trim().toLowerCase()).filter(Boolean)
            if (!terms.length) return this.openKeywords
            return this.openKeywords.filter(kw => terms.some(t => kw.toLowerCase().includes(t)))
        },
        filteredNotOpenKeywords() {
            const terms = this.searchNotOpenIncident.split(',').map(s => s.trim().toLowerCase()).filter(Boolean)
            if (!terms.length) return this.notOpenKeywords
            return this.notOpenKeywords.filter(kw => terms.some(t => kw.toLowerCase().includes(t)))
        },
        filteredSentenceRows() {
            const terms = this.searchSentence.split(',').map(s => s.trim().toLowerCase()).filter(Boolean)
            if (!terms.length) return this.sentenceRows
            return this.sentenceRows.filter(row => terms.some(t => row.value.toLowerCase().includes(t)))
        },
    },

    async mounted() {
        await this.loadInitialState()
    },

    methods: {
        appendToOpenSearch(kw) {
            const current = this.searchOpenIncident.trim()
            if (!current) {
                this.searchOpenIncident = kw
                return
            }
            const terms = current.split(',').map(s => s.trim())
            if (!terms.includes(kw)) {
                this.searchOpenIncident = current + ',' + kw
            }
        },
        onSearchNotOpenIncident() {

        },
        appendToSentenceSearch(value) {
            const current = this.searchSentence.trim()
            if (!current) {
                this.searchSentence = value
                return
            }
            const terms = current.split(',').map(s => s.trim())
            if (!terms.includes(value)) {
                this.searchSentence = current + ',' + value
            }
        },
        appendToNotOpenSearch(kw) {
            const current = this.searchNotOpenIncident.trim()
            if (!current) {
                this.searchNotOpenIncident = kw
                return
            }
            const terms = current.split(',').map(s => s.trim())
            if (!terms.includes(kw)) {
                this.searchNotOpenIncident = current + ',' + kw
            }
        },
        invalidateSavedState() {
            this.saveBtnText = 'Save'
            this.showSummary = false
            this.showProgress = false
        },
        addKeyword(intent) {
            const isOpen = intent === 'open-incident'
            const raw = isOpen ? this.openInput : this.notOpenInput
            const parts = [...new Set(raw.split(',').map(s => s.trim()).filter(Boolean))]
            if (!parts.length) return
            const list = isOpen ? this.openKeywords : this.notOpenKeywords
            const duplicates = parts.filter(kw => list.includes(kw))
            const unique = parts.filter(kw => !list.includes(kw))
            unique.forEach(kw => list.push(kw))
            if (isOpen) this.openInput = ''
            else this.notOpenInput = ''
            this.invalidateSavedState()
            if (duplicates.length) {
                this.$swal.fire({
                    icon: 'warning',
                    title: 'Duplicate Keyword',
                    text: `"${duplicates.join(', ')}" already exists and was skipped.`,
                })
            }
        },

        removeKeyword(intent, kw) {
            if (intent === 'open-incident') {
                this.openKeywords = this.openKeywords.filter(k => k !== kw)
            } else {
                this.notOpenKeywords = this.notOpenKeywords.filter(k => k !== kw)
            }
            this.invalidateSavedState()
        },
        createRow(value = '', expect = 'opencase') {
            return { id: ++this.rowIdCounter, value, expect, result: null, isCorrect: null, detail: null, emptyWarning: false }
        },

        addSentenceRow(value = '', focus = true, expect = 'opencase') {
            const row = this.createRow(value, expect)
            this.sentenceRows.push(row)
            this.invalidateSavedState()
            if (focus) {
                this.$nextTick(() => {
                    const container = this.$refs.sentenceRowsContainer
                    if (!container) return
                    const inputs = container.querySelectorAll('.sentence-input')
                    const last = inputs[inputs.length - 1]
                    if (last) last.focus()
                })
            }
            return row
        },

        deleteSentenceRow(index) {
            this.sentenceRows.splice(index, 1)
            if (!this.sentenceRows.length) this.addSentenceRow('', false)
            this.invalidateSavedState()
        },

        clearAll() {
            this.sentenceRows = []
            this.addSentenceRow('', false)
            this.showProgress = false
            this.testDone = 0
            this.testTotal = 0
            this.passCount = 0
            this.failCount = 0
            this.invalidateSavedState()
        },
        onSentenceBlur(row) {
            const value = row.value.trim()
            if (!value) return
            const idx = this.sentenceRows.indexOf(row)
            const isDuplicate = this.sentenceRows.some((r, i) => i !== idx && r.value.trim() === value)
            if (!isDuplicate) return
            this.sentenceRows.splice(idx, 1)
            if (!this.sentenceRows.length) this.addSentenceRow('', false)
            this.$swal.fire({
                icon: 'warning',
                title: 'Duplicate',
                text: `"${value}" already exists. The duplicate row has been removed.`,
            })
        },

        onSentenceInput(row) {
            row.emptyWarning = false
            row.result = null
            row.isCorrect = null
            row.detail = null
            this.invalidateSavedState()
        },

        onSentenceEnter(index) {
            if (index === this.sentenceRows.length - 1) {
                this.addSentenceRow()
            } else {
                this.$nextTick(() => {
                    const container = this.$refs.sentenceRowsContainer
                    if (!container) return
                    const inputs = container.querySelectorAll('.sentence-input')
                    if (inputs[index + 1]) inputs[index + 1].focus()
                })
            }
        },

        onSentencePaste(event, row) {
            const text = event.clipboardData?.getData('text')
            if (!text || (!text.includes('\n') && !text.includes(','))) return
            event.preventDefault()
            const parts = text.split(/[\n,]/).map(s => s.trim()).filter(Boolean)
            if (!parts.length) return
            const existing = this.sentenceRows.map(r => r.value.trim())
            const unique = [...new Set(parts)].filter(s => !existing.includes(s))
            if (!unique.length) return
            row.value = unique[0]
            for (let i = 1; i < unique.length; i++) {
                this.addSentenceRow(unique[i], false)
            }
            this.invalidateSavedState()
        },

        rowBgStyle(row) {
            if (row.emptyWarning) return { background: '#fefce8' }
            if (row.isCorrect === true) return { background: '#f0fdf4' }
            if (row.isCorrect === false) return { background: '#fef2f2' }
            return {}
        },
        buildPayload() {
            const openTestCases = []
            const notOpenTestCases = []
            this.sentenceRows.forEach(row => {
                const value = row.value.trim()
                if (!value) return
                if (row.expect === 'opencase') openTestCases.push(value)
                else notOpenTestCases.push(value)
            })
            return {
                open_incident: { keywords: [...this.openKeywords], test_cases: openTestCases },
                not_open_incident: { keywords: [...this.notOpenKeywords], test_cases: notOpenTestCases },
            }
        },
        async testSentences() {
            const emptyRows = this.sentenceRows.filter(row => !row.value.trim())
            if (emptyRows.length) {
                emptyRows.forEach(row => { row.emptyWarning = true })
                this.$swal.fire({
                    icon: 'error',
                    title: 'Try Again',
                    text: `${emptyRows.length} empty row(s) found. Please fill in or remove them before testing.`,
                })
                return
            }
            const testRows = this.sentenceRows.filter(row => row.value.trim())
            if (!testRows.length) return

            this.isTesting = true
            this.invalidateSavedState()
            this.sentenceRows.forEach(row => { row.result = null; row.isCorrect = null })
            this.lastFailIndex = -1
            this.testDone = 0
            this.testTotal = testRows.length
            this.passCount = 0
            this.failCount = 0
            this.showProgress = true
            this.showSummary = false

            for (const row of testRows) {
                const sentence = row.value.trim()
                const isExpectedOpen = row.expect === 'opencase'

                this.testBtnText = `Testing ${this.testDone + 1}/${testRows.length}...`

                const config = { ...this.buildPayload(), is_enabled: this.isEnabled }
                const payload = { subject: sentence, config }
                let url = '/api/classification/classify'
                try {
                    const response = await requestService.PostFetch('ccp', url, payload)
                    if (response.status == 200) {
                        const text = await response.text()
                        const data = text && JSON.parse(text)
                        const isOpen = data?.data?.result === true
                        const hasBothMatched = (data?.data?.matched_include?.length > 0) && (data?.data?.matched_not_include?.length > 0)
                        const isCorrect = !hasBothMatched && (isOpen === isExpectedOpen)
                        if (isCorrect) this.passCount++
                        else this.failCount++
                        row.result = isOpen ? 'opencase' : 'not-opencase'
                        row.isCorrect = isCorrect
                        row.detail = data?.data ?? null
                    }
                } catch (e) {
                    let errorMessage = 'Something went wrong. Please try again.'
                    try {
                        const parsed = typeof e === 'string' ? JSON.parse(e) : e
                        errorMessage = parsed?.error?.message || JSON.stringify(parsed)
                    } catch (_) {
                        errorMessage = String(e)
                    }
                    this.$swal.fire({ icon: 'error', title: 'Error', text: errorMessage })
                    break
                }

                this.testDone++
                this.showSummary = true
            }

            this.testBtnText = 'Test'
            this.isTesting = false
        },
        async saveSession() {
            const emptyRows = this.sentenceRows.filter(row => !row.value.trim())
            if (emptyRows.length) {
                emptyRows.forEach(row => { row.emptyWarning = true })
                this.$swal.fire({
                    icon: 'error',
                    title: 'Try Again',
                    text: `${emptyRows.length} empty row(s) found. Please fill in or remove them before saving.`,
                })
                return
            }

            const payload = { ...this.buildPayload(), is_enabled: this.isEnabled }

            this.$swal.fire({
                allowOutsideClick: false,
                didOpen: () => { this.$swal.showLoading() },
            })

            try {
                await requestService.PostFetch('ccp', '/api/classification/config', payload)
                this.$swal.fire({ icon: 'success', title: 'Saved', text: 'Configuration saved successfully.' })
                this.invalidateSavedState()
            } catch (error) {
                let errorMessage = 'Something went wrong. Please try again.'
                try {
                    const parsed = typeof error === 'string' ? JSON.parse(error) : error
                    errorMessage = parsed?.error?.message || JSON.stringify(parsed)
                } catch (_) {
                    errorMessage = String(error)
                }
                this.$swal.fire({ icon: 'error', title: 'Error', text: errorMessage })
            }
        },
        scrollToNextFail() {
            const container = this.$refs.sentenceRowsContainer
            if (!container) return
            const failRows = Array.from(container.querySelectorAll('.sentence-row')).filter(
                el => el.style.background === 'rgb(254, 242, 242)'
            )
            if (!failRows.length) return
            this.lastFailIndex = (this.lastFailIndex + 1) % failRows.length
            const row = failRows[this.lastFailIndex]
            row.scrollIntoView({ behavior: 'smooth', block: 'center' })
            const prev = row.style.outline
            row.style.outline = '2px solid #f87171'
            setTimeout(() => { row.style.outline = prev }, 1500)
        },
        async loadInitialState() {
            try {
                const response = await requestService.GetFetch('ccp', '/api/classification/config')
                if (response.status == 200) {
                    response.text().then((text) => {
                        const data = text && JSON.parse(text)
                        const latest = Array.isArray(data?.data) && data.data.length ? data.data[0] : null
                        this.openKeywords = latest?.open_incident?.keywords || []
                        this.notOpenKeywords = latest?.not_open_incident?.keywords || []
                        this.sentenceRows = []
                        this.isEnabled = latest?.is_enabled
                        const openCases = latest?.open_incident?.test_cases || []
                        const notOpenCases = latest?.not_open_incident?.test_cases || []
                        openCases.forEach(s => this.addSentenceRow(s, false, 'opencase'))
                        notOpenCases.forEach(s => this.addSentenceRow(s, false, 'not-opencase'))
                        if (!openCases.length && !notOpenCases.length) this.addSentenceRow('', false)
                    })
                }
            } catch (error) {
                this.addSentenceRow('', false)
            }
        },
        onImported(data) {
            const newOpenKw = (data.open_incident?.keywords || []).filter(k => !this.openKeywords.includes(k))
            const newNotOpenKw = (data.not_open_incident?.keywords || []).filter(k => !this.notOpenKeywords.includes(k))
            this.openKeywords.push(...newOpenKw)
            this.notOpenKeywords.push(...newNotOpenKw)

            const seen = new Set(this.sentenceRows.map(r => r.value.trim()))
            const openCases = [...new Set((data.open_incident?.test_cases || []).map(s => s.trim()).filter(Boolean))]
                .filter(s => !seen.has(s))
            openCases.forEach(s => { seen.add(s); this.addSentenceRow(s, false, 'opencase') })
            const notOpenCases = [...new Set((data.not_open_incident?.test_cases || []).map(s => s.trim()).filter(Boolean))]
                .filter(s => !seen.has(s))
            notOpenCases.forEach(s => this.addSentenceRow(s, false, 'not-opencase'))

            this.invalidateSavedState()
            this.$swal.fire({
                icon: 'success',
                title: 'Import Success',
            })
        },
        openRowDetail(row) {
            this.selectedRow = row
            this.$bvModal.show('modal-row-detail')
        },
        exportJSON() {
            const payload = this.buildPayload()
            const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' })
            const url = URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = 'bot-training-export.json'
            a.click()
            URL.revokeObjectURL(url)
        },

    },
}
</script>

<style scoped>
.trash-btn {
    color: #f87171 !important;
    cursor: pointer !important;
}

.trash-btn:hover {
    color: #ef4444 !important;
}

.sentence-row:hover,
.keyword-row:hover {
    background-color: #f9fafb;
}

.sentence-input:focus {
    border-bottom: 1px solid #7c3aed !important;
}

.sentence-search-btn {
    color: #d1d5db;
    opacity: 0;
    transition: opacity 0.15s;
}

.sentence-row:hover .sentence-search-btn {
    opacity: 1;
    color: #7c3aed;
}

.training-grid {
    display: grid;
    grid-template-columns: 15% 15% 1fr;
    gap: 1rem;
}

@media (max-width: 1199px) {
    .training-grid {
        grid-template-columns: 1fr;
        overflow-y: auto;
    }

    .training-grid>div {
        max-height: 400px;
    }
}
</style>
